import { Employee } from '../../../../domain/employees/employee';
import CitySelector from '../../../cities/components/CitySelector';
import DocumentTypeSelector from '../../../documents-types/components/DocumentTypeSelector';
import GroupSelector from '../../../groups/components/groupSelector';
import PositionSelector from '../../../positions/positionSelector';
import CheckBoxField from '../../../shared/components/forms/CheckBoxField';
import DateField from '../../../shared/components/forms/DateField';
import GenderSelector from '../../../shared/components/forms/GenderSelector';
import TextField from '../../../shared/components/forms/TextField';

interface Props {
    employee: Employee;
    isNewEmployee: boolean;
    onChange: (name: string, value: string | boolean | number[] | number | undefined) => void;
}

export default function PersonalInformationSection({
    employee,
    isNewEmployee,
    onChange: handleInputChange,
}: Props) {
    return (
        <>
            <h5 className='mb-3'>Datos Personales</h5>
            <div className='col-6'>
                <TextField
                    label='Primer nombre *'
                    name='firstName'
                    onChange={handleInputChange}
                    required={true}
                    value={employee.firstName}
                    key='firstName'
                />
            </div>
            <div className='col-6'>
                <TextField
                    label='Segundo nombre'
                    name='middleName'
                    onChange={handleInputChange}
                    required={false}
                    value={employee.middleName}
                    key='middleName'
                />
            </div>
            <div className='col-6'>
                <TextField
                    label='Primer apellido *'
                    name='lastName'
                    onChange={handleInputChange}
                    required={true}
                    value={employee.lastName}
                    key='lastName'
                />
            </div>
            <div className='col-6'>
                <TextField
                    label='Segundo apellido'
                    name='surname'
                    onChange={handleInputChange}
                    required={false}
                    value={employee.surname}
                    key='surname'
                />
            </div>
            <div className='col-6'>
                <DocumentTypeSelector
                    onChange={handleInputChange}
                    value={employee.documentTypeId}
                    name='documentTypeId'
                />
            </div>
            <div className='col-6'>
                <TextField
                    label='No. Documento *'
                    name='documentNumber'
                    onChange={handleInputChange}
                    required={false}
                    value={employee.documentNumber}
                    key='documentNumber'
                />
            </div>
            <div className='col-4'>
                <CitySelector
                    name='cityId'
                    onChange={handleInputChange}
                    value={employee.cityId}
                />
            </div>
            <div className='col-4'>
                <DateField
                    label='Fecha de nacimiento'
                    name='birthDate'
                    onChange={handleInputChange}
                    required={false}
                    value={employee.birthDate}
                    key='birthDate'
                />
            </div>
            <div className='col-4'>
                <GenderSelector
                    name='gender'
                    label='Género'
                    onChange={handleInputChange}
                    key='gender'
                    value={employee.gender}
                />
            </div>
            <div className='col-4'>
                <PositionSelector
                    name='positionId'
                    onChange={handleInputChange}
                    value={employee.positionId}
                />
            </div>
            <div className='col-4'>
                <GroupSelector
                    name='groupId'
                    onChange={handleInputChange}
                    value={employee.groupId}
                />
            </div>
            <div className='col-4'>
                <CheckBoxField
                    label='Está Activo? *'
                    name='isActive'
                    onChange={handleInputChange}
                    disabled={isNewEmployee}
                    value={employee.isActive}
                />
            </div>
        </>
    );
}
